import {Check} from '@mui/icons-material'
import {LoadingButton} from '@mui/lab'
import {useMediaQuery, useTheme} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type Props = {
  isValid?: boolean
  isSubmitting?: boolean
  isDirty?: boolean
}

export const InteractiveSubmitButton = ({isValid, isSubmitting, isDirty}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const disabledSubmit = !isValid || isSubmitting || !isDirty
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <LoadingButton
      key="submit-button"
      type="submit"
      data-test-id="submit-button"
      variant="contained"
      startIcon={<Check />}
      loadingPosition="start"
      loading={isSubmitting}
      disabled={disabledSubmit}
      fullWidth={isSmall}
    >
      {t('form.action.save')}
    </LoadingButton>
  )
}
